// extracted by mini-css-extract-plugin
module.exports = {"removeIconFromEntity":"IanosEnergy_removeIconFromEntity__34AAC"};